class DesignerImagesMenu {

  constructor(config) {
    this.app = config.app;


    // 2nd drop down menu ( Images )
    safeAddListener("select_board", "click", () => {
      const dialog = document.getElementById("boardsDialog");
      if (dialog) dialog.showModal();
    });

    safeAddListener("select_track", "click", () => this.openSelectTrackDialog());
    
    safeAddListener("upload_image", "click", () => {
      const input = document.getElementById("imageFileInput");
      if (input) input.click();
    });

    safeAddListener("select_object", "click", () => {
      if (!this.app.getBaseLayer()) {
        showMessage("Notice", "You must select a board first");
      } else {
          const dialog = document.getElementById("svgObjectsDialog");
          if (dialog) dialog.showModal();
      }
    });

    safeAddListener("select_cutout", "click", () => {
      if (!this.app.getBaseLayer()) {
        showMessage("Notice", "You must select a board first");
      } else {
        if (this.app.getBoard().can_choose_cutout) {
          const dialog = document.getElementById("svgCutoutsDialog");
          if (dialog) dialog.showModal();
        } else {
          showMessage("Notice", "This board does not allow for custom cutouts");
        }
      }
    });

    safeAddListener("add_shape_rectangle", "click", () => { if (this.app.checkBoard()) this.addShapeRectangle(); });
    safeAddListener("add_shape_circle", "click", () => { if (this.app.checkBoard()) this.addShapeCircle(); });
    safeAddListener("add_shape_ellipse", "click", () => { if (this.app.checkBoard()) this.addShapeEllipse(); });
    safeAddListener("add_shape_star", "click", () => { if (this.app.checkBoard()) this.addShapeStar(); });
    safeAddListener("add_shape_arrow", "click", () => { if (this.app.checkBoard()) this.addShapeArrow(); });
    safeAddListener("add_shape_multisided", "click", () => { if (this.app.checkBoard()) this.addShapeMultiSided(); });
    safeAddListener("add_shape_wedge", "click", () => { if (this.app.checkBoard()) this.addShapeWedge(); });
    safeAddListener("add_shape_arc", "click", () => { if (this.app.checkBoard()) this.addShapeArc(); });
    safeAddListener("add_shape_heart", "click", () => { if (this.app.checkBoard()) this.addShapeHeart(); });
    safeAddListener("add_shape_teardrop", "click", () => { if (this.app.checkBoard()) this.addShapeTeardrop(); });




    // Upload Image
    // Process uploaded image
    document.addEventListener("DOMContentLoaded", () => {
      document.getElementById("imageFileInput").addEventListener("change", (event) => {
        const file = event.target.files[0]; // Get the selected file

        if (!file) {
          console.error("No file uploaded");
          return;
        }

        // Check if the file type is an image
        if (
          file.type !== "image/jpeg" &&
          file.type !== "image/png" &&
          file.type !== "image/webp" &&
          file.type !== "image/svg+xml"
        ) {
          console.error("not a valid file image type");
          return;
        }

        const reader = new FileReader();

        // What to do when the file is successfully read
        reader.onload = (e) => {
          const fileContents = e.target.result;

          if (file.type === "image/svg+xml") {
            //img = fileContents;
            addSvgImage(arrayBufferToUtf8String(fileContents), 60 + getBaseLayer().width() / 2, 60 + getBaseLayer().height() / 2);
            return;
          }

          const blob = new Blob([fileContents], { type: file.type });
          const imageUrl = URL.createObjectURL(blob);
          let img = new Image();

          img.onload = () => {
            // 5. Create Konva.Image after HTMLImageElement is loaded
            let loadedImage = new Konva.Image({
              x: 60 + this.app.getBaseLayer().width() / 2,
              y: 60 + this.app.getBaseLayer().height() / 2,
              image: img,
              width: img.width, // Use original image dimensions
              height: img.height,
              draggable: false,
              name: "uploadedImage",
              type: "imageupload",
            });

            loadedImage.attrs.imageURI = loadedImage.toDataURL();

            // Optional: Scale down if image is too large for the stage
            const maxDimension = Math.max(img.width, img.height);
            const stageMax = Math.min(this.app.getStage().width(), this.app.getStage().height());
            if (maxDimension > stageMax * 0.8) {
              // If image is larger than 80% of stage
              const scale = (stageMax * 0.8) / maxDimension;
              loadedImage.width(img.width * scale);
              loadedImage.height(img.height * scale);
            }

            loadedImage.offset({
              x: loadedImage.width() / 2,
              y: loadedImage.height() / 2,
            });

            this.app.getLayer().add(loadedImage);
            loadedImage.filters([
              Konva.Filters.Grayscale,
              Konva.Filters.WhiteToTransparent,
            ]);
            loadedImage.cache();
            this.app.getLayer().draw();

            //layer.children[layer.children.length-1].moveToBottom();
            //layer.children[0].moveUp();

            this.app.selectNode(loadedImage);

            // IMPORTANT: Revoke the Object URL to release memory when the image is no longer needed
            // or when the page is unloaded. For this example, we'll revoke it immediately
            // as the HTMLImageElement has now loaded the data. If you needed the URL
            // for other purposes, you might revoke it later.
            URL.revokeObjectURL(imageUrl);
          };

          img.onerror = () => {
            statusDiv.textContent = "Error loading image from URL.";
            statusDiv.classList.add("error");
            URL.revokeObjectURL(imageUrl); // Revoke even on error
          };

          img.src = imageUrl; // Set the image source

          document.getElementById("imageFileInput").value = "";
        };

        // What to do if an error occurs during reading
        reader.onerror = (e) => {
          console.error("FileReader error:", reader.error);
        };

        // Read the file as binary
        reader.readAsArrayBuffer(file);
      });
    });




  }




  openSelectTrackDialog() {
    let bl = this.app.getBaseLayer();

    if (!bl) {
      showMessage("Notice", "You must select a board before you pick a track.");
    } else if (this.app.getCanAddTrack(bl.attrs.name) == false) {
      showMessage("Notice", "This cribbage board does not allow for custom tracks.");
    } else if (this.app.getTrack() != null) {
      showMessage("Notice", "You already have a track added to this board.");
    } else {
      document.getElementById("tracksDialog").showModal();
    }
  }


  addShapeRectangle(attrs = {}) {
    let shape = new Konva.Rect({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      width: attrs.width ?? 200,
      height: attrs.height ?? 200,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      cornerRadius: attrs.cornerRadius ?? 10,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeCircle(attrs = {}) {
    let shape = new Konva.Circle({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      radius: attrs.radius ?? 100,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeEllipse(attrs = {}) {
    let shape = new Konva.Ellipse({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      radius: attrs.radius ?? 20,
      radiusX: attrs.radiusX ?? 100,
      radiusY: attrs.radiusY ?? 50,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeStar(attrs = {}) {
    let shape = new Konva.Star({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      numPoints: attrs.numPoints ?? 5,
      innerRadius: attrs.innerRadius ?? 50,
      outerRadius: attrs.outerRadius ?? 100,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    //console.log("pos", this.app.getNextNodePos());
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeArrow(attrs = {}) {
    let shape = new Konva.Arrow({
      type: "shape",
      stroke: engraveColor,
      fill: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      points: attrs.points ?? [0, 0, 200, 0],
      pointerLength: attrs.pointerLength ?? 20,
      pointerWidth: attrs.pointerWidth ?? 20,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeMultiSided(attrs = {}) {
    let shape = new Konva.RegularPolygon({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      sides: attrs.sides ?? 6,
      radius: attrs.radius ?? 150,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeWedge(attrs = {}) {
    let shape = new WedgeShape({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      angle: attrs.angle ?? 22.5,
      radius: attrs.radius ?? 300,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeArc(attrs = {}) {
    let shape = new Konva.Arc({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      angle: attrs.angle ?? 22.5,
      innerRadius: attrs.innerRadius ?? 200,
      outerRadius: attrs.outerRadius ?? 400,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeHeart(attrs = {}) {
    let shape = new HeartShape({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      width: attrs.width ?? 200,
      height: attrs.height ?? 200,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }


  addShapeTeardrop(attrs = {}) {
    let shape = new TeardropShape({
      type: "shape",
      stroke: engraveColor,
      strokeWidth: attrs.strokeWidth ?? 5,
      width: attrs.width ?? 200,
      x: attrs.x ?? 200,
      y: attrs.y ?? 200,
      draggable: false,
      sortable: true,
      strokeScaleEnabled: false,
      canResize: false,
      canScale: false,
    });

    this.app.getLayer().add(shape);
    shape.zIndex(this.app.getNextNodePos());
    this.app.selectNode(shape);
  }








}



  

